
import { mapGetters } from 'vuex';
import UiToast from '@/components/ui/Toast/index.js';
import { removeToast } from '@/components/ui/Toast/index.js';
export default {
  name: 'GlobalCodeBox',
  computed: {
    ...mapGetters(['$bus']),
  },
  beforeMount() {
    this.$bus.$on('rocket:ui:showToast', (type, value, time) => {
      UiToast(type, value, time);
    });
    this.$bus.$on('rocket:ui:closeAllToast', () => {
      removeToast();
    });
  },
  beforeDestroy() {
    removeToast();
    this.$bus.$off('rocket:ui:toast');
    this.$bus.$off('rocket:ui:closeAllToast');
  },
};
